import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "health-coverage"
};
const _hoisted_2 = {
  class: "plan-faq-custom-container pt-sm-5"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "col-12"
};
const _hoisted_5 = {
  id: "accordionExampleTerms",
  class: "accordion"
};
const _hoisted_6 = ["id"];
const _hoisted_7 = ["aria-controls", "data-bs-target"];
const _hoisted_8 = ["id", "aria-labelledby"];
const _hoisted_9 = {
  class: "accordion-body"
};
const _hoisted_10 = ["innerHTML"];
import "bootstrap/dist/js/bootstrap.min.js";
import { useMeta } from "vue-meta";
export default {
  __name: 'planFaqs',
  props: ['questions'],
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.questions, (question, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: question.id,
          class: "accordion-term"
        }, [_createElementVNode("h5", {
          id: 'heading' + index,
          class: "accordion-header"
        }, [_createElementVNode("button", {
          "aria-controls": 'collapse' + index,
          class: _normalizeClass([{
            collapsed: index !== 0
          }, "accordion-button h5"]),
          "data-bs-target": '#collapse' + index,
          "aria-expanded": "true",
          "data-bs-toggle": "collapse",
          type: "button"
        }, _toDisplayString(question.Heading), 11, _hoisted_7)], 8, _hoisted_6), _createElementVNode("div", {
          id: 'collapse' + index,
          "aria-labelledby": 'heading' + index,
          class: _normalizeClass([{
            show: index === 0
          }, "accordion-collapse collapse"]),
          "data-bs-parent": "#accordionExampleTerms"
        }, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.details, para => {
          return _openBlock(), _createElementBlock("p", {
            class: "body-3",
            innerHTML: para.p
          }, null, 8, _hoisted_10);
        }), 256))])], 10, _hoisted_8), _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))]);
      }), 128))])])])])]);
    };
  }
};